// @flow
import { TextOnlySearchEditor } from '../../common/TextOnlySearch';

export const ServerGroupSearch = TextOnlySearchEditor;